import { API_URL, Blog_API_TOKEN, ENV } from '../../config';
import { applyPreproductionSettings } from '../../utils/PreproductionSettings';

const fetchWithAuth = async (url: string) => {
  url = applyPreproductionSettings(url);
  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${Blog_API_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const fetchBlogPlans = async (lang: string, ott: boolean) => {
  try {
    let langpart = '';
    if (lang.indexOf('zh') > -1) {
      langpart = "&locale=zh-Hant-HK&fallbackLocale=false";
    }

    const platformParams = ott
      ? 'filters[PriceOptions][$notNull]=true'
      : 'filters[PriceOptionsSTB][$notNull]=true';
    const plansResponse = await fetchWithAuth(
      `${API_URL}/plans?${platformParams}&populate=*&pagination[limit]=-1${langpart}`
    );
    const comboPacksResponse = await fetchWithAuth(
      `${API_URL}/combo-packs?populate=*&pagination[limit]=-1${langpart}`
    );

    const plans = plansResponse.data;
    const comboPacks = comboPacksResponse.data;

    plans.forEach((plan: any) => {
      plan.attributes.includes.data = plan.attributes.includes.data.map((include: any) => {
        const matchingComboPack = comboPacks.find((comboPack: any) => comboPack.id === include.id);
        return matchingComboPack ? matchingComboPack : include;
      });
    });

    console.log('fetchBlogPlans API Response:', plans);
    return plans.length > 0 ? plans : null;
  } catch (error) {
    console.error('Error fetching packs.', error);
    return null;
  }
};